module.exports = __webpack_public_path__ + "static/media/timeline2.20bab7a7.jpg";